import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { iosContext, isStandalone } from './lib/telegram';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// /admin — панель распорядителя: отдельный корень, свой вход и своя тема.
// /tv — короткая ссылка для телевизора: та же панель, сразу табло идущего турнира.
// Каждая ветка подгружается отдельно, чтобы стили админки и мини-аппа не мешали друг другу.
const isAdminRoute = /^\/(admin|tv)(\/|$)/.test(window.location.pathname);

if (isAdminRoute) {
  import('./admin-panel/AdminRoot').then(({ default: AdminRoot }) => root.render(<AdminRoot />));
} else if (iosContext() === 'safari' && !isStandalone()) {
  // iPhone/iPad в браузере: показываем, как поставить HOUSE иконкой на экран
  // «Домой» — с неё сайт открывается на весь экран, как приложение.
  Promise.all([import('./index.css'), import('./screens/InstallScreen')]).then(([, { default: InstallScreen }]) =>
    root.render(<InstallScreen />),
  );
} else {
  if (!(window as unknown as { Telegram?: { WebApp?: { initData?: string } } }).Telegram?.WebApp?.initData) {
    // Вне Telegram (сайт, в том числе с иконки на весь экран) отступ под вырез
    // и статус-бар берём у системы: SDK Telegram здесь выставляет его нулём, а
    // вёрстка читает именно --tg-safe-area-inset-*. Снизу отступа нет — приложение
    // на весь экран до самого края, в том числе нижнее меню (--app-bottom-inset).
    for (const side of ['top', 'left', 'right']) {
      document.documentElement.style.setProperty(`--tg-safe-area-inset-${side}`, `env(safe-area-inset-${side})`);
    }
    document.documentElement.style.setProperty('--app-bottom-inset', '0px');
    document.documentElement.classList.add('web-app');
  }
  Promise.all([
    import('./index.css'),
    import('./App'),
    import('./state/DataProvider'),
    import('./state/cart'),
    import('./lib/tonconnect'),
  ]).then(([, { default: App }, { default: DataProvider }, { default: CartProvider }, { default: TonConnectProvider }]) =>
    root.render(
      <React.StrictMode>
        <TonConnectProvider>
          <DataProvider>
            <CartProvider>
              <App />
            </CartProvider>
          </DataProvider>
        </TonConnectProvider>
      </React.StrictMode>,
    ),
  );
}

// Кеш картинок (обложки, меню бара, баннеры) — см. public/sw.js. Только в
// проде: в dev CRA и так гоняет всё с диска, а SW только путал бы с кешем
// при живой правке кода.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
